<template>
  <div id="modal_future_creator" :class="{modal_big: true, modal_queue_notification: true, show: isShowing}">
    <div class="modal_rule_container" :style="{'background-image': backgroundStyle}">
      <div class="btn_close">
        <img class="lazyload" :data-src="contentCloudFront('/assets/v1/future_creator_close.png')" @click="hide()">
      </div>
      <div v-show="step === 1" class="step_1">
        <div class="btn_apply_now" @click="goToNextStep()">APPLY NOW FOR EARLY ACCESS</div>
        <div class="btn_skip" @click="skip()">SKIP</div>
      </div>
      <div v-show="step === 2" class="step_2">
        <div class="input_group">
          <div class="input_title">ENTER YOUR EMAIL FOR MORE INFO</div>
          <input v-model="email" class="input_field" type="text">
        </div>
        <div class="btn_apply" @click="apply()">APPLY</div>
      </div>
    </div>
  </div>
</template>

<script>
import { component } from '../../mixins/component';
import {
  EventBus,
  SHOW_MODAL_BOOM_MESSAGE,
  SHOW_MODAL_FUTURE_CREATOR,
} from '../../event-bus';
import View from '../View';

export default {
  extends: View,
  mixins: [component],
  props: {
    background: {
      type: String,
      default() {
        return '';
      },
    },
    commandShow: {
      type: String,
      default() {
        return '';
      },
    },
    enablePopup: {
      type: Number,
      default() {
        return 0;
      },
    },
    timeToShow: {
      type: Number,
      default() {
        return 60000;
      },
    },
  },
  data() {
    return {
      isShowing: false,
      step: 1,
      email: '',
      backgroundStyle: '',
    };
  },
  mounted() {
    if (this.commandShow === 'show_future_creator_modal') {
      this.show();
    }
  },
  created() {
    this.background = decodeURIComponent(this.background);
    this.backgroundStyle = 'url(' + this.background + ')';
    EventBus.$on(SHOW_MODAL_FUTURE_CREATOR, (step = 1) => {
      this.step = step;
      this.show();
    });
  },
  beforeDestroy() {
    EventBus.$off(SHOW_MODAL_FUTURE_CREATOR);
  },
  methods: {
    show() {
      if (!this.enablePopup) {
        return;
      }
      this.isShowing = true;
    },
    hide() {
      this.isShowing = false;
    },
    skip() {
      const that = this;
      this.hide();
      setTimeout(function() {
        that.show();
      }, 60 * 1000);
    },
    goToNextStep() {
      this.step = 2;
    },
    apply() {
      if (!this.testEmail(this.email)) {
        EventBus.$emit(SHOW_MODAL_BOOM_MESSAGE, 'Please input a valid email!');
        return;
      }
      const config = {
        headers: {
          'X-CSRF-TOKEN': this.appConfig.csrfToken,
        },
      };
      this.$http.post('/apply-future-creator', {
        email: this.email,
      }, config).then((response) => {
        EventBus.$emit(SHOW_MODAL_BOOM_MESSAGE, response.data.msg);
        if (response.data.status === 0) {
          this.hide();
        }
      }).catch(error => {
        console.log(error);
        EventBus.$emit(SHOW_MODAL_BOOM_MESSAGE, 'Something went wrong!');
      });
    },
    testEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
  },
};
</script>
